import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

const NEIGHBORHOODS = [
  'East End',
  'West End',
  'Bay Farm Island',
  'Gold Coast',
  'South Shore',
  'Fernside',
  'Central Alameda',
  'Alameda Point',
];

export function OnboardingPage() {
  const navigate = useNavigate();
  const { fetchUser } = useAuthStore();
  const [displayName, setDisplayName] = useState('');
  const [username, setUsername] = useState('');
  const [bio, setBio] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/onboarding', {
        display_name: displayName,
        username: username.toLowerCase().replace(/[^a-z0-9_]/g, ''),
        bio,
        neighborhood: neighborhood || undefined,
      });
      await fetchUser();
      navigate('/feed');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand-200 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-sand-800">Welcome to Vibration 👋</h1>
          <p className="text-sand-500 text-sm mt-1">Let's set up your profile.</p>
        </div>

        <div className="card p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-sand-600 mb-1">Display Name *</label>
              <input
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="How your neighbors will see you"
                required
                className="input w-full"
                autoFocus
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-sand-600 mb-1">Username *</label>
              <div className="flex items-center">
                <span className="text-sand-500 text-sm mr-1">@</span>
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ''))}
                  placeholder="yourname"
                  required
                  minLength={3}
                  maxLength={30}
                  className="input w-full"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-sand-600 mb-1">Bio</label>
              <textarea
                value={bio}
                onChange={(e) => setBio(e.target.value)}
                placeholder="A little about yourself..."
                rows={2}
                className="input w-full resize-none"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-sand-600 mb-1">Neighborhood</label>
              <select
                value={neighborhood}
                onChange={(e) => setNeighborhood(e.target.value)}
                className="input w-full"
              >
                <option value="">Select your area (optional)</option>
                {NEIGHBORHOODS.map((n) => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>

            {error && <p className="text-red-600 text-xs">{error}</p>}

            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? 'Saving...' : 'Get started'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
